import RaceImage from './RaceImage';

export default RaceImage;
